import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { EventCustomRegFieldAvailValues } from '../../../shared/custom-reg-fields/event-custom-reg-field-avail-values.model';

@Component({
  selector: 'wl-event-v4-settings-registration-field-drop-down-values',
  styleUrls: ['event-v4-settings-registration-drop-down-values.component.css'],
  templateUrl: 'event-v4-settings-registration-drop-down-values.component.html',
    standalone: false
})
export class EventV4SettingsRegistrationDropDownValuesComponent implements OnInit {
  public innerValue: EventCustomRegFieldAvailValues;

  @Output('remove') public removeEvent: EventEmitter<any> = new EventEmitter<any>();

  public constructor() {
    this.innerValue = new EventCustomRegFieldAvailValues();
  }

  @Input()
  get availableValue(): any {
    return this.innerValue;
  }
  set availableValue(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
    }
  }

  ngOnInit() {}

  public remove(): void {
    this.removeEvent.emit();
  }
}
